<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14.5 14.5"
    aria-hidden="true"
  >
    <path
      id="Path_472"
      data-name="Path 472"
      d="M7.267.264a7,7,0,1,0,7,7,7.012,7.012,0,0,0-7-7Zm0,1.272A5.729,5.729,0,1,1,1.536,7.262,5.715,5.715,0,0,1,7.267,1.536ZM6.806,3.29a.636.636,0,0,0-.18.456V7.262a.636.636,0,0,0,.189.45L9.36,10.258a.636.636,0,1,0,.9-.9L7.9,7V3.745a.636.636,0,0,0-.184-.461.8.8,0,0,0-.449-.2A.866.866,0,0,0,6.806,3.29Z"
      transform="translate(-0.014 -0.014)"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="0.5"
      fill-rule="evenodd"
    />
  </svg>
</template>
